module.exports = __webpack_public_path__ + "static/img/TexelAppMock.2642644.png";